import { useMemo } from "react";
import { buildSupportConversation } from "@/services/support/supportConversation";
import type { SupportComment, SupportMessage } from "@/types/support";

type UseSupportConversationOptions = {
  includeInternal?: boolean;
  customerId?: string;
};

export function useSupportConversation(
  comments: SupportComment[] = [],
  messages: SupportMessage[] = [],
  options?: UseSupportConversationOptions,
) {
  return useMemo(
    () => buildSupportConversation(comments, messages, options),
    [comments, messages, options?.includeInternal, options?.customerId],
  );
}
